import { log } from "../../../utils/log.ts";
import { checkIfTokenIsNeedingUpdate } from "../tokenUpdateStrategy";

export const overrideFetch = () => {
  log('overrideFetch initialized');
  const originalFetch = window.fetch;

  const interceptedFetch = async (input, init = {}) => {
    const url = typeof input === "string" ? input : input?.url;
    const isBFFGraphQL = url?.includes(process.env.BFF_URL)
    const body = typeof init.body === "string" ? init.body : undefined;

    if (isBFFGraphQL && init.method === "POST" && body){
      const newToken = await checkIfTokenIsNeedingUpdate(body);
      if (newToken) {
        const headers = new Headers(init.headers || {});
        headers.set("Authorization", `Bearer ${newToken}`);
        log("Substituindo Authorization em fetch por token renovado");
        return originalFetch(input, {...init, headers });
      }
    }

    return originalFetch(input, init);
  };

  window.fetch = interceptedFetch;
};
